(() => {
  const initialize = (anchorLinks) => {
    const element = anchorLinks.element;
    const navAnchorLinks = element.querySelectorAll('.anchor-links__link');
    const anchorLinksInContent = document.querySelectorAll('.paragraph-anchor');
    const button = element.querySelector('.anchor-links__toggle');
    const list = element.querySelector('.anchor-links__list');
    const headerHeight = document.querySelector('.header').offsetHeight + element.offsetHeight;

    Array.from(document.querySelectorAll('.paragraph-anchor')).map((anchor) => {
      anchor.style.scrollMarginTop = `${headerHeight}px`;
    });

    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 1,
    };

    function setCurrent(links) {
      links.forEach((link) => {
        if (link.isIntersecting === true) {
          const targetId = `#${link.target.id}`;

          navAnchorLinks.forEach((alink) => {
            const href = alink.href.match(/#(.*)/g);
            alink.classList.remove('anchor-links__link--current');

            if (targetId === href[0]) {
              alink.classList.add('anchor-links__link--current');
            }
          });
        }
      });
    }

    const observeAnchorLinks = new IntersectionObserver(setCurrent, options);

    const toggle = (e) => {
      e.preventDefault();
      list.classList.toggle('anchor-links__list--hidden');
      button.classList.toggle('anchor-links__toggle--active');
    };

    const current = (e) => {
      const link = e.target;
      navAnchorLinks.forEach((link) => link.classList.remove('anchor-links__link--current'));
      link.classList.toggle('anchor-links__link--current');
    };

    navAnchorLinks.forEach((link) => link.addEventListener('click', current));
    button.addEventListener('click', toggle);

    if (window.matchMedia('(max-width: 767px)').matches) {
      list.classList.add('anchor-links__list--hidden');
    } else {
      anchorLinksInContent.forEach((link) => observeAnchorLinks.observe(link));
    }
  };

  const anchorLinks = stp.setup('anchor-links');

  anchorLinks.map(initialize);
})();
